<template>
  <va-sidebar :minimized="minimized">
    <template slot="menu">
      
      <va-sidebar-link v-if="ability.can('read', 'Dashboard')"
        :minimized="minimized"
        :activeByDefault="'dashboard' === $route.name"
        :icon="[ 'sidebar-menu-item-icon vuestic-iconset', 'vuestic-iconset-dashboard' ]"
        :to="{ name: 'dashboard' }">
        <span slot="title">{{ $t('menu.dashboard') }}</span>
      </va-sidebar-link>
      
      <va-sidebar-link v-if="ability.can('manage', 'Companies')"
        :minimized="minimized"
        :activeByDefault="'companies' === $route.name"
        :icon="[ 'sidebar-menu-item-icon vuestic-iconset', 'vuestic-iconset-dashboard' ]"
        :to="{ name: 'companies' }">
        <span slot="title">{{ $t('menu.companies') }}</span>
      </va-sidebar-link>

      <va-sidebar-link-group v-if="ability.can('view', 'DailyOperationMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-auth']"
        :title="$t('menu.operations')"
        :children="DailyOperationItens">
        
        <va-sidebar-link
          v-for="(subMenuItem, key) in DailyOperationItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'AssemblyLineMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-time']"
        :title="$t('menu.assemblyLine')"
        :children="AssemblyLineItens">
        
        <va-sidebar-link
          v-for="(subMenuItem, key) in AssemblyLineItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'IndicatorsMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-statistics']"
        :title="$t('menu.indicators')"
        :children="IndicatorsItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in IndicatorsItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'LoadsMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-maps']"
        :title="$t('menu.loads')"
        :children="LoadsItens">
        
         <va-sidebar-link
          v-for="(subMenuItem, key) in LoadsItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />
    
      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'TransportsMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon va-icon fa fa-truck']"
        :title="$t('menu.transports')"
        :children="TransportItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in TransportItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'ProductsMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-components']"
        :title="$t('menu.products')"
        :children="ProductItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in ProductItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />
      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'UsersMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-user']"
        :title="$t('menu.users')"
        :children="UserItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in UserItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />
      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'AddressesMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-files']"
        :title="$t('menu.addresses')"
        :children="AddressItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in AddressItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />
      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'MountingFlowMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-graph']"
        :title="$t('menu.mounting_flow')"
        :children="MountingFlowItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in MountingFlowItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'AuditMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-forms']"
        :title="$t('menu.audits')"
        :children="AuditItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in AuditItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'SetupMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-tables']"
        :title="$t('menu.data_report')"
        :children="DataReportItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in DataReportItens"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

      <va-sidebar-link-group v-if="ability.can('view', 'SetupMenu')"
        :minimized="minimized"
        :icon="['sidebar-menu-item-icon vuestic-iconset vuestic-iconset-settings']"
        :title="$t('menu.setup')"
        :children="SetupItens">

        <va-sidebar-link
          v-for="(subMenuItem, key) in SetupItens" v-if="ability.can('read', subMenuItem.subject_class)"
          :key="key"
          :to="{ name: subMenuItem.name }"
          :title="$t(subMenuItem.displayName)"
        />

      </va-sidebar-link-group>

    </template>
  </va-sidebar>
</template>

<script>
import { mapState } from "vuex";
import { Ability } from '@casl/ability'
import { AssemblyLineMenu } from './sub-menus/AssemblyLineMenu'
import { IndicatorMenu } from './sub-menus/IndicatorMenu'
import { LoadMenu } from './sub-menus/LoadMenu'
import { TransportMenu } from './sub-menus/TransportMenu'
import { ProductMenu } from './sub-menus/ProductMenu'
import { UserMenu } from './sub-menus/UserMenu'
import { AddressMenu } from './sub-menus/AddressMenu'
import { MountingFlowMenu } from './sub-menus/MountingFlowMenu'
import { DailyOperationMenu } from './sub-menus/DailyOperationMenu'
import { AuditMenu } from './sub-menus/AuditMenu'
import { SetupMenu } from './sub-menus/SetupMenu'
import { DataReportMenu } from './sub-menus/DataReportMenu'

export const ability = new Ability()

export default {
  name: 'app-sidebar',
  components: {
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      ability: [],
      AssemblyLineItens: [],
      IndicatorsItens: [],
      LoadsItens: [],
      TransportItens: [],
      ProductItens: [],
      UserItens: [],
      AddressItens: [],
      MountingFlowItens: [],
      DailyOperationItens: [],
      SetupItens: [],
      AuditItens: [],
      DataReportItens: [],
    }
  },
  computed: {
    ...mapState(['rules']),
  },

  beforeMount () {
    this.ability = ability.update(this.rules)
  },

  mounted () {
    this.AssemblyLineItens = AssemblyLineMenu.routes
    this.IndicatorsItens = IndicatorMenu.routes
    this.LoadsItens = LoadMenu.routes
    this.TransportItens = TransportMenu.routes
    this.ProductItens = ProductMenu.routes
    this.UserItens = UserMenu.routes
    this.AddressItens = AddressMenu.routes
    this.MountingFlowItens = MountingFlowMenu.routes
    this.DailyOperationItens = DailyOperationMenu.routes
    this.SetupItens = SetupMenu.routes
    this.AuditItens = AuditMenu.routes
    this.DataReportItens = DataReportMenu.routes
  },
}

</script>
